module.exports = __webpack_public_path__ + "static/drinkTicket-2e6a5a92ff502553c142143eada1a1d3.jpg";